export default {
      id: "ic_forgot_password_otp-usage",
      viewBox: "0 0 56 56",
      url: "/" + "images/icons.3.109.2.svg#ic_forgot_password_otp-usage",
      toString: function () {
        return this.url;
      }
    }